export default __webpack_public_path__ + "static/media/MY_TRACKER_ICON_3.7eab7d55.svg";